// Angular
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
// NGRX
import { Store } from '@ngrx/store';

// RxJS
// AppState
import { AppState } from '../../../core/reducers';

@Component({
  selector: 'kt-shipments',
  templateUrl: './shipments.component.html',
  styleUrls: ['./shipments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShipmentsComponent {
  constructor(
    private store: Store<AppState>,
    private router: Router
  ) {}
}
